import { render, staticRenderFns } from "./RenewDataView.vue?vue&type=template&id=4c9fd44e"
import script from "./RenewDataView.vue?vue&type=script&lang=js"
export * from "./RenewDataView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports